export enum Physics {
  CPM = 'cpm',
  VQ3 = 'vq3',
}
